import { render, staticRenderFns } from "./ListItemForm.vue?vue&type=template&id=5507c479"
import script from "./ListItemForm.vue?vue&type=script&lang=ts"
export * from "./ListItemForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports